import { render, staticRenderFns } from "./FileLinkPip.vue?vue&type=template&id=036509f7"
import script from "./FileLinkPip.vue?vue&type=script&lang=ts"
export * from "./FileLinkPip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports